import { useState } from "react";
import { generateWalletInvoice } from "../services/walletService";

const GenerateWalletInvoice = ({ transactionId, btnWidth }) => {
  const [isBusy, setIsBusy] = useState(false);

  const createInvoice = async () => {
    const response = await generateWalletInvoice({ transactionId: transactionId });
    const blob = new Blob([response.data], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(blob);
    setIsBusy(false);
    window.open(fileURL);
  };
  return (
    <button
      onClick={() => {
        setIsBusy(true);
        createInvoice();
      }}
      className={`btn btn-sm badge bg-success-transparent ms-1 w-${btnWidth} py-2`}
      disabled={isBusy === true ? true : false}
    >
      {isBusy === true ? (
        <span
          className="spinner-border spinner-border-xs"
          role="status"
          aria-hidden="true"
        ></span>
      ) : (
        <>
          <i className="ri-printer-line me-1 fw-medium align-middle d-none d-md-inline"></i>
          PRINT
        </>
      )}
    </button>
  );
};

export default GenerateWalletInvoice;
